function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function (_typeof2) { function _typeof(_x) { return _typeof2.apply(this, arguments); } _typeof.toString = function () { return _typeof2.toString(); }; return _typeof; }(function (obj) { return typeof obj; }); } else { _typeof = function (_typeof3) { function _typeof(_x2) { return _typeof3.apply(this, arguments); } _typeof.toString = function () { return _typeof3.toString(); }; return _typeof; }(function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }); } return _typeof(obj); }

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { getNestedValue } from './../utils';
import { VueComponent } from '@progress/kendo-vue-common';
import Component from 'vue-class-component';
import { provideIntlService } from '@progress/kendo-vue-intl';
/**
 * @hidden
 */

var GridCell =
/** @class */
function (_super) {
  __extends(GridCell, _super);

  function GridCell() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  GridCell.prototype.triggerClick = function () {
    this.$emit('click', {
      dataItem: this.$props.dataItem,
      field: this.$props.field
    });
  };

  GridCell.prototype.triggerEdit = function (dataItem) {
    this.$emit('edit', dataItem);
  };

  GridCell.prototype.triggerAdd = function (dataItem) {
    this.$emit('add', dataItem);
  };

  GridCell.prototype.triggerCancel = function (dataItem) {
    this.$emit('cancel', dataItem);
  };

  GridCell.prototype.triggerSave = function (dataItem) {
    this.$emit('save', dataItem);
  };

  GridCell.prototype.triggerRemove = function (dataItem) {
    this.$emit('remove', dataItem);
  };
  /**
   * @hidden
   */
  // @ts-ignore


  GridCell.prototype.render = function (h) {
    var defaultRendering = null;

    if (this.$props.rowType === 'groupFooter') {
      defaultRendering = h("td", {
        "class": this.$props.className
      });
    } else if (this.$props.field !== undefined && this.$props.rowType !== 'groupHeader') {
      var data = getNestedValue(this.$props.field, this.$props.dataItem);
      var dataAsString = '';

      if (data !== undefined && data !== null) {
        dataAsString = this.$props.format ? provideIntlService(this).format(this.$props.format, data) : data.toString();
      }

      defaultRendering = h("td", {
        attrs: {
          colSpan: this.$props.colSpan
        },
        "class": this.$props.className,
        on: {
          "click": this.triggerClick
        }
      }, [dataAsString]);
    }

    if (this.$props.render) {
      var events = __assign({
        click: this.triggerClick,
        edit: this.triggerEdit,
        add: this.triggerAdd,
        cancel: this.triggerCancel,
        save: this.triggerSave,
        remove: this.triggerRemove
      }, this.$props.render.listeners);

      if (this.$props.render.type === 'slot') {
        return this.$props.render.render({
          props: this.$props,
          listeners: events,
          methods: events
        })[0];
      } else if (this.$props.render.type === 'renderFunction') {
        return this.$props.render.render(h, defaultRendering, this.$props, events);
      } else {
        return h(this.$props.render.render, {
          props: this.$props,
          on: events
        });
      }
    } else {
      return defaultRendering;
    }
  };

  GridCell = __decorate([Component({
    props: {
      field: String,
      dataItem: Object,
      format: String,
      className: String,
      colSpan: Number,
      columnIndex: Number,
      columnsCount: Number,
      rowType: String,
      level: Number,
      expanded: Boolean,
      editor: String,
      render: [String, Function, Object]
    },
    inject: {
      kendoIntlService: {
        default: null
      }
    }
  })], GridCell);
  return GridCell;
}(VueComponent);

export { GridCell };